module.exports = __webpack_public_path__ + "static/media/mailchimp.39a8822e.svg";